import React, { useState, useEffect } from "react";
import { ImageSelector } from "./ImageSelector";

export const HowToReachTrek = ({ location, onSubmit }) => {
  const [formData, setFormData] = useState({
    howToReachTrek: [],
  });

  useEffect(() => {
    if (location && location.howToReachTrek) {
      setFormData({
        howToReachTrek: location.howToReachTrek.map((item) => ({
          ...item,
          selfDrive: item.selfDrive || {
            routes: [],
            googleMapLink: "",
            vehicleParking: "",
            note: ""
          },
          travelOptions: {
            publicTransport: Array.isArray(item.travelOptions?.publicTransport) ? item.travelOptions.publicTransport : [],
            train: Array.isArray(item.travelOptions?.train) ? item.travelOptions.train : [],
            airport: Array.isArray(item.travelOptions?.airport) ? item.travelOptions.airport : [],
          },
        })),
      });
    }
  }, [location]);



  const addLocation = () => {
    setFormData((prev) => ({
      howToReachTrek: [
        ...prev.howToReachTrek,
        {
          base: "",
          trekTime: "",
          nearestTown: "",
          selfDrive: {
            routes: [],
            googleMapLink: "",
            vehicleParking: "",
            note: "",
          },
          travelOptions: {
            publicTransport: [],
            train: [],
            airport: [],
          },
          commonNote: "",
        },
      ],
    }));
  };


  // Remove a location
  const removeLocation = (index) => {
    const updatedFormData = JSON.parse(JSON.stringify(formData));
    updatedFormData.howToReachTrek.splice(index, 1);
    setFormData(updatedFormData);
  };

  // Update a location field
  const handleLocationChange = (locationIndex, field, value) => {
    const updatedFormData = JSON.parse(JSON.stringify(formData)); // Deep copy
    const fieldParts = field.split('.'); // Split field into parts if nested

    if (fieldParts.length > 1) {
      // Handle nested fields like "selfDrive.googleMapLink"
      updatedFormData.howToReachTrek[locationIndex][fieldParts[0]][fieldParts[1]] = value;
    } else {
      // Handle non-nested fields
      updatedFormData.howToReachTrek[locationIndex][field] = value;
    }

    setFormData(updatedFormData); // Update state
  };

  // Add a route inside selfDrive
  const addRoute = (locationIndex) => {
    const updatedFormData = JSON.parse(JSON.stringify(formData));
    updatedFormData.howToReachTrek[locationIndex].selfDrive.routes.push({ route: "" });
    setFormData(updatedFormData);
  };

  // Remove a route inside selfDrive
  const removeRoute = (locationIndex, routeIndex) => {
    const updatedFormData = JSON.parse(JSON.stringify(formData));
    updatedFormData.howToReachTrek[locationIndex].selfDrive.routes.splice(routeIndex, 1);

    setFormData(updatedFormData);
  };

  // Update a route field inside selfDrive
  const handleRouteChange = (locationIndex, routeIndex, value) => {
    const updatedFormData = JSON.parse(JSON.stringify(formData));
    updatedFormData.howToReachTrek[locationIndex].selfDrive.routes[routeIndex].route = value;

    setFormData(updatedFormData);
  };


  // ✅ Handle image selection for each location
  const handleImageSelection = (image, locationIndex) => {
    setFormData((prev) => {
      // ✅ Create a deep copy of the previous state
      const updatedHowToReachTrek = prev.howToReachTrek.map((item, i) =>
        i === locationIndex ? { ...item, baseImage: image } : item
      );

      return { howToReachTrek: updatedHowToReachTrek }; // ✅ Return the updated state
    });
  };


  const handleTravelOptionChange = (locationIndex, option, index, field, value) => {
    setFormData((prev) => {
      const updatedLocations = JSON.parse(JSON.stringify(prev));
      updatedLocations.howToReachTrek[locationIndex].travelOptions[option][index][field] = value;
      return updatedLocations;
    });
  };


  const addTravelOption = (locationIndex, option) => {
    setFormData((prev) => {
      const updatedLocations = JSON.parse(JSON.stringify(prev));

      const newEntry = {
        publicTransport: {
          busAvailableFrom: "",
          busFrequency: "",
          shareTaxi: "",
          localTaxi: "",
          note: "",
        },
        train: {
          nearestStation: "",
          trainFrequency: "",
          note: "",
        },
        airport: {
          nearestAirport: "",
          services: "",
          note: "",
        },
      }[option];

      updatedLocations.howToReachTrek[locationIndex].travelOptions[option].push(newEntry);
      return updatedLocations;
    });
  };


  const removeTravelOption = (locationIndex, option, index) => {
    setFormData((prev) => {
      const updatedLocations = JSON.parse(JSON.stringify(prev));
      updatedLocations.howToReachTrek[locationIndex].travelOptions[option].splice(index, 1);
      return updatedLocations;
    });
  };


  // Handle form submission
  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit({ howToReachTrek: formData.howToReachTrek });

    }
  };

  return (
    <div style={{ padding: "15px" }}>
      <h3>How To Reach</h3>
      <button type="button" onClick={addLocation} className="btn-blue">
        Add Location
      </button>
      {formData.howToReachTrek.map((location, locationIndex) => (
        <form key={locationIndex} style={{ marginBottom: "20px" }}>
          <h4>Location {locationIndex + 1}</h4>
          <div className="row">
            <div className="inputWrapper col-3 p-2">
              <label>Base</label>
              <input
                type="text"
                placeholder="Base"
                value={location.base}
                onChange={(e) =>
                  handleLocationChange(locationIndex, "base", e.target.value)
                }
              />
            </div>
            <div className="inputWrapper col-3 p-2">
              <label>Trek Time</label>
              <input
                type="text"
                placeholder="Trek Time"
                value={location.trekTime}
                onChange={(e) =>
                  handleLocationChange(locationIndex, "trekTime", e.target.value)
                }
              />
            </div>
            <div className="inputWrapper col-3 p-2">
              <label>Nearest Town</label>
              <input
                type="text"
                placeholder="Nearest Town"
                value={location.nearestTown}
                onChange={(e) =>
                  handleLocationChange(locationIndex, "nearestTown", e.target.value)
                }
              />
            </div>
            <div className="inputWrapper col-3 p-2">
              <label>Base Location Image</label>
              <ImageSelector
                selectedImage={location.baseImage}
                handleImageSelection={(image) => handleImageSelection(image, locationIndex)} // Pass handler
              />
            </div>
          </div>
          <h5>Self Drive</h5>
          <div className="row">
            <div className="inputWrapper col-3 p-2">
              <label>Google Map Link</label>
              <input
                type="text"
                placeholder="Google Map Link"
                value={location.selfDrive?.googleMapLink || ""}
                onChange={(e) =>
                  handleLocationChange(locationIndex, "selfDrive.googleMapLink", e.target.value)
                }

              />
            </div>
            <div className="inputWrapper col-3 p-2">
              <label>Vehicle Parking</label>
              <input
                type="text"
                placeholder="Vehicle Parking"
                value={location.selfDrive?.vehicleParking || ""}
                onChange={(e) =>
                  handleLocationChange(
                    locationIndex,
                    "selfDrive.vehicleParking",
                    e.target.value
                  )
                }
              />
            </div>
            <div className="inputWrapper col-3 p-2">
              <label>Note</label>
              <textarea
                placeholder="Self Drive Note"
                value={location.selfDrive?.note || ""}
                onChange={(e) =>
                  handleLocationChange(locationIndex, "selfDrive.note", e.target.value)
                }
              />
            </div>
          </div>


          {Array.isArray(location.selfDrive?.routes) &&
            location.selfDrive.routes.length >= 1 ? (  // ✅ Ensure there's at least one route
            location.selfDrive.routes.map((route, routeIndex) => (
              <div key={routeIndex} className="row">
                <div className="inputWrapper col-3 p-2">
                  <label>Route</label>
                  <input
                    type="text"
                    placeholder="Route"
                    value={route.route || ""}
                    onChange={(e) =>
                      handleRouteChange(locationIndex, routeIndex, e.target.value)
                    }
                  />
                </div>
                <div className="inputWrapper col-3 p-2">
                  <div className="row">
                    <button type="button" onClick={() => addRoute(locationIndex)}>Add Route</button>
                    <button type="button" onClick={() => removeRoute(locationIndex, routeIndex)}>Remove Route</button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="row">
              <div className="inputWrapper col-3 p-2">
                <button type="button" onClick={() => addRoute(locationIndex)}>Add Route</button>
              </div>
            </div>
          )
          }



          <h5>Travel Options</h5>
          <div className="travelOptions">
            {["publicTransport", "train", "airport"].map((option) => (
              <div key={option} style={{ marginBottom: "15px" }}>
                <h6><b>{option === "publicTransport" ? "Public Transport" : option === "train" ? "Train" : "Airport"}</b></h6>

                {/* ✅ Add Button for this specific option */}
                <button type="button" onClick={() => addTravelOption(locationIndex, option)}>
                  Add {option === "publicTransport" ? "Public Transport" : option === "train" ? "Train" : "Airport"}
                </button>

                {/* ✅ Looping through dynamically added travel options */}
                {Array.isArray(location.travelOptions[option]) &&
                  location.travelOptions[option].map((travelOption, index) => (
                    <div key={index} className="row" style={{ flexWrap: "wrap" }}>

                      {/* ✅ Public Transport Fields */}
                      {option === "publicTransport" && (
                        <>
                          <div className="inputWrapper col-3 p-2">
                            <label>Bus Available From</label>
                            <input
                              type="text"
                              placeholder="Bus Available From"
                              value={travelOption.busAvailableFrom}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "publicTransport", index, "busAvailableFrom", e.target.value)
                              }
                            />
                          </div>

                          <div className="inputWrapper col-3 p-2">
                            <label>Bus Frequency</label>
                            <input
                              type="text"
                              placeholder="Bus Frequency"
                              value={travelOption.busFrequency}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "publicTransport", index, "busFrequency", e.target.value)
                              }
                            />
                          </div>

                          <div className="inputWrapper col-3 p-2">
                            <label>Share Taxi</label>
                            <input
                              type="text"
                              placeholder="Share Taxi"
                              value={travelOption.shareTaxi}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "publicTransport", index, "shareTaxi", e.target.value)
                              }
                            />
                          </div>

                          <div className="inputWrapper col-3 p-2">
                            <label>Local Taxi</label>
                            <input
                              type="text"
                              placeholder="Local Taxi"
                              value={travelOption.localTaxi}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "publicTransport", index, "localTaxi", e.target.value)
                              }
                            />
                          </div>

                          <div className="inputWrapper col-3 p-2">
                            <label>Note</label>
                            <textarea
                              placeholder="Public Transport Note"
                              value={travelOption.note}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "publicTransport", index, "note", e.target.value)
                              }
                            />
                          </div>
                        </>
                      )}

                      {/* ✅ Train Fields */}
                      {option === "train" && (
                        <>
                          <div className="inputWrapper col-3 p-2">
                            <label>Nearest Station</label>
                            <input
                              type="text"
                              placeholder="Nearest Station"
                              value={travelOption.nearestStation}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "train", index, "nearestStation", e.target.value)
                              }
                            />
                          </div>

                          <div className="inputWrapper col-3 p-2">
                            <label>Train Frequency</label>
                            <input
                              type="text"
                              placeholder="Train Frequency"
                              value={travelOption.trainFrequency}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "train", index, "trainFrequency", e.target.value)
                              }
                            />
                          </div>

                          <div className="inputWrapper col-3 p-2">
                            <label>Note</label>
                            <textarea
                              placeholder="Train Note"
                              value={travelOption.note}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "train", index, "note", e.target.value)
                              }
                            />
                          </div>
                        </>
                      )}

                      {/* ✅ Airport Fields */}
                      {option === "airport" && (
                        <>
                          <div className="inputWrapper col-3 p-2">
                            <label>Nearest Airport</label>
                            <input
                              type="text"
                              placeholder="Nearest Airport"
                              value={travelOption.nearestAirport}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "airport", index, "nearestAirport", e.target.value)
                              }
                            />
                          </div>

                          <div className="inputWrapper col-3 p-2">
                            <label>Services</label>
                            <input
                              type="text"
                              placeholder="Services"
                              value={travelOption.services}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "airport", index, "services", e.target.value)
                              }
                            />
                          </div>

                          <div className="inputWrapper col-3 p-2">
                            <label>Note</label>
                            <textarea
                              placeholder="Airport Note"
                              value={travelOption.note}
                              onChange={(e) =>
                                handleTravelOptionChange(locationIndex, "airport", index, "note", e.target.value)
                              }
                            />
                          </div>
                        </>
                      )}

                      {/* ✅ Dedicated Remove Button for this specific option */}
                      <div className="inputWrapper col-3 p-2">
                        <button type="button" onClick={() => removeTravelOption(locationIndex, option, index)}>
                          Remove {option === "publicTransport" ? "Public Transport" : option === "train" ? "Train" : "Airport"}
                        </button>
                      </div>

                    </div>
                  ))}
              </div>
            ))}
          </div>
          <div className="inputWrapper col-6 p-2">
            <label>Common Note</label>
            <textarea
              placeholder="Add a common note for this location"
              value={location.commonNote}
              onChange={(e) =>
                handleLocationChange(locationIndex, "commonNote", e.target.value)
              }
              style={{
                width: "100%",
                height: "80px",
                padding: "10px",
                resize: "none",
              }}
            />
          </div>
          <button type="button" className="deleteButton" onClick={() => removeLocation(locationIndex)}>
            Remove Location
          </button>
          <hr style={{ margin: "30px 0px" }} />
        </form>
      ))}
      <button type="button" onClick={handleSubmit} className="btn-blue">
        Submit
      </button>
    </div>
  );
};

export const HowToReachTravel = () => {
  return (
    <></>
  )
}